// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__PUU7j","description":"styles_description__RlPz_","title":"styles_title__QPVtP"};